module.exports = __webpack_public_path__ + "res/img_other_action_neutral.4c4c56a98f8f6140bbfb659f79c24dcf.png";